export default __webpack_public_path__ + "static/media/wright_copy_3CD609F4385EA.92776f36.jpg";